import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_JUSTIFICATIVA](state) {
		state.justificativa = String('')
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_JUSTIFICATIVA](state, justificativa) {
		state.transferirSaldo.justificativa = justificativa
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_TOTAL_ELEMENTS](state, totalElements) {
		if (totalElements) state.totalElements = totalElements
		else state.totalElements = 0
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_TOTAL_PAGES](state, totalPages) {
		if (totalPages) state.totalPages = totalPages
		else state.totalPages = 0
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_DATASOURCE](state) {
		state.datasource = []
		state.totalElements = 0
		state.totalPages = 0
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_ORGAO_CEDENTE](state, orgao) {
		state.orgaoCedente = orgao
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltro(state.filtro)
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESET_ALTERACOES_TRANSFERENCIA](state) {
		state.orgaoCedente = {
			idUo: null,
			sigla: null,
			estoque: null,
			tipoAlteracaoSaldo: null,
		}

		state.filtro = {
			orgaoCessionario: {},
			campoBusca: null,
			idCedente: null,
			idItemAta: null,
		}

		state.transferirSaldo = {
			idItemAta: null,
			idUoCessionario: null,
			idUoCedente: null,
			quantidadeTransferencia: null,
			numeroOficio: null,
			justificativa: '',
		}
	},
}
